import { Component, input, output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { StrideLogStudentFieldComponent } from '../../../fields/standard/stride-log-student-field/stride-log-student-field.component';

@Component({
	selector: 'app-stride-algorithm-report-filter-form',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, StrideLogStudentFieldComponent],
	templateUrl: './stride-algorithm-report-filter-form.component.html',
	styleUrl: './stride-algorithm-report-filter-form.component.scss',
})
export class StrideAlgorithmReportFilterFormComponent {
	public clientUuid = input<string | undefined>(undefined);
	public onStudentSelectedEmitter = output<string>({ alias: 'onStudentSelected' });

	public form: FormGroup = this.fb.group({
		studentUuid: ['', []],
	});

	constructor(private fb: FormBuilder) {}

	public onChange(): void {
		const studentUuid = this.form.value.studentUuid;

		if (studentUuid) {
			this.onStudentSelectedEmitter.emit(studentUuid);
		}
	}

	public setStudentUuid(studentUuid: string): void {
		this.form.patchValue({ studentUuid }, { emitEvent: false });
	}
}
